<div class="bg-col-w p-l-5 p-r-5 p-t-6 p-b-6">

  <h6 class="col-1 h3"
  *iCms="'title' of content"></h6>
  <div class="col-1 p2 m-t-5"
  *iCms="'copy' of content; content: 'html'"></div>

  <ul class="block m-t-2 custom-scrollbar overflow-auto"
    [style.maxHeight.vh]="50">
    @for (item of surchargeTable; track $index) {
      <li
        class="flex flex-justify-between p-t-2 p-b-1 b-b b-col-53 o1">
        <span>{{item.country}}</span>
        <price [value]="item.price"></price>
      </li>
    }
  </ul>
</div>
<i class="icon-close cursor-pointer pos-absolute top-4 right-4"
(click)="close()"></i>